import { useEffect, useRef } from "react";

export function useYouTubePlayOnView() {
  const ref = useRef(null);

  useEffect(() => {
    const iframe = ref.current;
    if (!iframe) return;
    let observer;
    let hasPlayed = false;
    if ('IntersectionObserver' in window) {
      observer = new window.IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting && !hasPlayed) {
            // PostMessage API to play YouTube video
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'playVideo', args: [] }),
              '*'
            );
            hasPlayed = true;
          } else if (!entry.isIntersecting && hasPlayed) {
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }),
              '*'
            );
            hasPlayed = false;
          }
        },
        { threshold: 0.5 }
      );
      observer.observe(iframe);
    }
    return () => {
      if (observer && iframe) observer.unobserve(iframe);
    };
  }, []);

  return ref;
}
